import React from 'react'
import { Link } from 'react-router-dom'

import styles from '../styles.module.scss'

interface PatientNameCellProps {
  patientUuid: string
  name: string
}

const PatientNameCell = ({ patientUuid, name }: PatientNameCellProps) => {
  if (!name) return null

  return patientUuid ? (
    <Link
      to={`/admin/patients/${patientUuid}/memberships`}
      className={styles.profileLink}
      onClick={(e) => e.stopPropagation()}
    >
      {name}
    </Link>
  ) : (
    <>{name}</>
  )
}

export default PatientNameCell
